import { useLocation, Link } from "react-router-dom";
import { ROUTES } from "../../../routes/AppRouterConfig";
import Catalogs from "./Catalogs";
import Certificates from "./Certificates";
import Instructions from "./Instructions";
import Drawings from "./Drawings";
import BimModels from "./BimModels";

const Documentation = () => {
  const location = useLocation();

  // Маппинг URL на названия вкладок
  const urlToTabMap = {
    [ROUTES.DocumentationCatalogs.path]: "catalogs",
    [ROUTES.DocumentationCertificates.path]: "certificates",
    [ROUTES.DocumentationInstructions.path]: "instructions",
    [ROUTES.DocumentationDrawings.path]: "drawings",
    [ROUTES.DocumentationBimModels.path]: "BIM-models",
  };

  // Маппинг названий вкладок на URL
  const tabToUrlMap = {
    catalogs: ROUTES.DocumentationCatalogs.path,
    certificates: ROUTES.DocumentationCertificates.path,
    instructions: ROUTES.DocumentationInstructions.path,
    drawings: ROUTES.DocumentationDrawings.path,
    "BIM-models": ROUTES.DocumentationBimModels.path,
  };

  // Определяем текущую вкладку на основе URL
  const getCurrentTab = () => {
    // Нормализуем pathname, убирая завершающий слэш
    const normalizedPath = location.pathname.replace(/\/$/, "");

    // Проверяем точное совпадение
    if (urlToTabMap[normalizedPath]) {
      return urlToTabMap[normalizedPath];
    }

    // Проверяем, начинается ли путь с маршрута чертежей (для секций)
    if (normalizedPath.startsWith(ROUTES.DocumentationDrawings.path + "/")) {
      return "drawings";
    }

    return "catalogs";
  };

  const currentTab = getCurrentTab();

  const renderCurrentComponent = () => {
    switch (currentTab) {
      case "catalogs":
        return <Catalogs />;
      case "certificates":
        return <Certificates />;
      case "instructions":
        return <Instructions />;
      case "drawings":
        return <Drawings />;
      case "BIM-models":
        return <BimModels />;
      default:
        return <Catalogs />;
    }
  };

  return (
    <div className="documentation page-width">
      <div className="flex-column gap-8x w-100">
        {/* Вкладки навигации */}
        <nav
          className="selection-tabs page-width_large flex-column"
          aria-label="Разделы документации"
        >
          <div className="tab-items_container flex-row">
            <div className="tab-items flex-row flex-between">
              <Link
                to={tabToUrlMap.catalogs}
                className={`tab-item${
                  currentTab === "catalogs" ? " active" : ""
                }`}
              >
                Каталоги
              </Link>
              <Link
                to={tabToUrlMap.certificates}
                className={`tab-item${
                  currentTab === "certificates" ? " active" : ""
                }`}
              >
                Сертификаты
              </Link>
              <Link
                to={tabToUrlMap.instructions}
                className={`tab-item${
                  currentTab === "instructions" ? " active" : ""
                }`}
              >
                Инструкции
              </Link>
              <Link
                to={tabToUrlMap.drawings}
                className={`tab-item${
                  currentTab === "drawings" ? " active" : ""
                }`}
              >
                Чертежи
              </Link>
              {/* Временно скрыты */}
              {/* <Link
                to={tabToUrlMap["BIM-models"]}
                className={`tab-item${
                  currentTab === "BIM-models" ? " active" : ""
                }`}
              >
                BIM-модели
              </Link> */}
            </div>
          </div>
        </nav>

        {renderCurrentComponent()}
      </div>
    </div>
  );
};

export default Documentation;
